export default __webpack_public_path__ + "static/media/photo--sm--freshbooks.0c381eca.jpg";